// platform-mfa-totp: /settings/security — "אפליקציית אימות" של המשתמש עצמו (מתפריט המשתמש): פעילה / לא פעילה, הפעלה, החלפת מכשיר
// (דורשת סשן aal2 — השער כבר דאג לקוד), והנחיות השחזור. האדמין מאפס למשתמשים אחרים ממסך המשתמשים.
import { useEffect, useState } from 'react';
import { useDocTitle } from '../lib/brand.ts';
import { fetchMfaStatus, setMfaStatus, useMfaStatus } from '../lib/mfa.ts';
import { T } from '../lib/strings.ts';
import { Button } from '../components/ui/button.tsx';
import { MfaEnroll } from '../components/Mfa.tsx';
import { ErrorView, Loading } from '../components/Status.tsx';
import { IconCheck, IconShield } from '../components/brand/icons.tsx';

export function SecurityPage() {
  useDocTitle(T.mfa.page);
  const status = useMfaStatus();
  const [err, setErr] = useState<unknown>(null);
  const [editing, setEditing] = useState(false);
  const reload = () => {
    setErr(null);
    fetchMfaStatus().then((st) => setMfaStatus(st)).catch(setErr);
  };
  const loaded = !!status;
  useEffect(() => {
    // טעינה ראשונה בלבד (כשהשער כבר טען — לא שוב)
    if (!loaded) fetchMfaStatus().then((st) => setMfaStatus(st)).catch(setErr);
  }, [loaded]);

  return (
    <section className="flex max-w-2xl flex-col gap-5" data-testid="security-page">
      <header className="flex flex-col gap-1">
        <h1 className="page-title">{T.mfa.page}</h1>
      </header>
      {err != null && <ErrorView error={err} onRetry={reload} />}
      {!status && err == null && <Loading />}
      {status && !editing && (
        <div className="flex flex-col gap-4 rounded-md border border-border bg-card p-5 shadow-card" data-testid="mfa-state" data-enrolled={status.enrolled}>
          <div className="flex items-start gap-3">
            <span className={status.enrolled ? 'text-[hsl(var(--state-ok))]' : 'text-muted-foreground'}>{status.enrolled ? <IconCheck size={24} /> : <IconShield size={24} />}</span>
            <div className="flex flex-col gap-1">
              <b className="text-base">{status.enrolled ? T.mfa.settings.on : T.mfa.settings.off}</b>
              <p className="m-0 text-sm text-muted-foreground">{status.enrolled ? T.mfa.settings.onLead : T.mfa.settings.offLead}</p>
            </div>
          </div>
          <Button className="self-start" variant={status.enrolled ? 'outline' : 'default'} onClick={() => setEditing(true)} data-testid={status.enrolled ? 'mfa-replace' : 'mfa-start'}>
            {status.enrolled ? T.mfa.enroll.replace : T.mfa.enroll.start}
          </Button>
        </div>
      )}
      {status && editing && (
        <div className="rounded-md border border-border bg-card p-5 shadow-card">
          <MfaEnroll
            mode={status.enrolled ? 'replace' : 'settings'}
            onDone={() => {
              setEditing(false);
              setMfaStatus(null, null);
              reload();
            }}
            onCancel={() => setEditing(false)}
          />
        </div>
      )}
    </section>
  );
}
